import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Pagination } from '../models';
import { VisumVersion } from '../models/VisumVersion';
import { BaseApiService } from './baseApiService';
import { StorageKey } from './storage.service';

@Injectable({
  providedIn: 'root'
})
export class VisumVersionService extends BaseApiService<VisumVersion> {
  get cacheKey(): StorageKey {
    return StorageKey.colorServiceCache;
  }

  getUrl(operation: string, params, id: string = null): string {
    const url = `${environment.apiUrl}/visum/version`;
    return url;
  }

  list(params: {[params: string]: string}): Promise<Pagination<VisumVersion>> {
    return super.list(this.removeContractId(params));
  }

  get() {
    const url = `${environment.apiUrl}/visum/version`;
    return this.http.get<VisumVersion>(url, { headers: new HttpHeaders({ 'content-Type': 'application/json' }) });
  }

  protected unparse(obj) {
    return VisumVersion.unparse(obj);
  }

  protected parse(obj) {
    return VisumVersion.parse(obj);
  }

}
